const IMAGES = {
  logo: require("../img/logo.png"),
  ycoin: require("../img/wallet-2-64.png"),
  // leaderboard
  first: require("../img/leaderboard/one.png"),
  second: require("../img/leaderboard/two.png"),
  third: require("../img/leaderboard/three.png"),
  // contact
  support: require("../img/support.png"),
  wasupport: require("../img/wasupport.png"),
  // socials
  facebook: require("../img/socials/facebook.png"),
  instagram: require("../img/socials/instagram.png"),
  whatsapp: require("../img/socials/logo.png"),
  telegram: require("../img/socials/telegram.png"),
  gmail: require("../img/socials/gmail.png"),
  // payments
  phonepe: require("./payments/phonepe.png"),
  gpay: require("./payments/gpay.png"),
  paytm: require("./payments/paytm.png"),
  upi: require("./payments/upi.png"),
  // bg
  loginbg: require("./loginbg.png"),
};

export default IMAGES;
